// extracted by mini-css-extract-plugin
export default {"icon":"LinkGroup_icon--J8N","link":"LinkGroup_link--qGQ"};